import { render, staticRenderFns } from "./OilModal.vue?vue&type=template&id=3b717842&"
import script from "./OilModal.vue?vue&type=script&lang=js&"
export * from "./OilModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports